import { Link } from 'react-router-dom';
import { usePageMeta } from '../../lib/use-page-meta';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  usePageMeta({
    title: '404 · ViBE',
    description: 'Page not found.',
  });

  return (
    <section className={`${styles.section} container-wide`}>
      <p className={styles.eyebrow}>404 · Insufficient evidence</p>
      <h1 className={styles.headline}>
        This page is tracked, but not ranked.
      </h1>
      <p className={styles.body}>
        The address you requested does not currently match a published page. It may have been a model that has
        since been retired, a route that no longer exists, or a typo in a shared link. Either way, the leaderboard
        is the right place to start.
      </p>
      <Link to="/" className={styles.cta}>Return to the leaderboard →</Link>
    </section>
  );
}
